import { gql } from '@grandvisionhq/graphql';
import { appointmentFragment } from '../../../fragments/appointment.js';
import { failures } from './fragments/failures.js';

const RESCHEDULE_APPOINTMENT_BY_TOKEN = gql`
  mutation RescheduleAppointmentByToken($token: String!, $startTime: String!, $endTime: String!) {
    rescheduleAppointmentByToken(token: $token, startTime: $startTime, endTime: $endTime) {
      ... on RescheduleAppointmentResponse {
        appointment {
          ...AppointmentFragment
        }
        failures {
          ...FailureMessage
        }
      }
    }
  }
  ${appointmentFragment}
  ${failures}
`;

export { RESCHEDULE_APPOINTMENT_BY_TOKEN };
//# sourceMappingURL=reschedule-appointment-by-token.js.map
